
export enum QOP_TEMP {
    JP_LIGHT,
    ZH_LIGHT,
    NOODLE_LIGHT,
    JP_DARK,
    NOODLE_DARK,
    HOT_DARK,
    FIRE_DARK,
    CN_LIGHT,
    CUSTOMIZE_LIGHT,
    CUSTOMIZE_DARK,
}

export const getQopTempById = (sta: number) => {
    const statusText = new Map([
        [1, QOP_TEMP.JP_LIGHT],
        [2, QOP_TEMP.ZH_LIGHT],
        [3, QOP_TEMP.NOODLE_LIGHT],
        [4, QOP_TEMP.JP_DARK],
        [5, QOP_TEMP.NOODLE_DARK],
        [6, QOP_TEMP.HOT_DARK],
        [7, QOP_TEMP.FIRE_DARK],
        [8, QOP_TEMP.CN_LIGHT],
        [-1, QOP_TEMP.CUSTOMIZE_LIGHT],
        [-2, QOP_TEMP.CUSTOMIZE_DARK]
    ]);
    return statusText.get(sta) as QOP_TEMP;
}


export type qopTheme = {
    resColor: string;
    tableColor: string;
    wifiIconColor: string;
    wifiInFoColor: string;
    wifiIconBorder: string;
    tableIconBorder: string;
    cusCodeBorder: string;
    iconBorderColor: string;
    tipBorderColor: string;
    tipBorderFillColor: string;
}

export const getTempTheme = (sta: any) => {
    const statusText = new Map([
        [
            QOP_TEMP.JP_LIGHT,
            JSON.stringify({
                resColor: 'rgba(0, 0, 0, 0.7)',
                tableColor: '#193041',
                wifiIconColor: '#D8A854',
                wifiInFoColor: '#000',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '',
                tipBorderColor: '#cccccc',
                tipBorderFillColor: '#fff',
            })
        ],
        [
            QOP_TEMP.ZH_LIGHT,
            JSON.stringify({
                resColor: 'rgba(0, 0, 0, 0.7)',
                tableColor: '#2E291E',
                wifiIconColor: '#DE7B25',
                wifiInFoColor: '#000',
                wifiIconBorder: '2px solid #DE7B25',
                tableIconBorder: '2px solid #DE7B25',
                iconBorderColor: '#DE7B25',
                cusCodeBorder: '',
                tipBorderColor: '#cccccc',
                tipBorderFillColor: '#fff',
            })
        ],
        [
            QOP_TEMP.NOODLE_LIGHT,
            JSON.stringify({
                resColor: 'rgba(0, 0, 0, 0.7)',
                tableColor: '#273839',
                wifiIconColor: '#D59931',
                wifiInFoColor: '#000',
                wifiIconBorder: '2px solid #AB803F',
                tableIconBorder: '2px solid #AB803F',
                iconBorderColor: '#AB803F',
                cusCodeBorder: '',
                tipBorderColor: '#cccccc',
                tipBorderFillColor: '#fff',
            })
        ],
        [
            QOP_TEMP.JP_DARK,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#837D6F',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
        [
            QOP_TEMP.NOODLE_DARK,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#837D6F',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
        [
            QOP_TEMP.HOT_DARK,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#837D6F',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
        [
            QOP_TEMP.FIRE_DARK,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#837D6F',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
        [
            QOP_TEMP.CN_LIGHT,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#E6B163',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #EBB769',
                tableIconBorder: '2px solid #EBB769',
                iconBorderColor: '#EBB769',
                cusCodeBorder: '',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
        // 自定义 light
        [
            QOP_TEMP.CUSTOMIZE_LIGHT,
            JSON.stringify({
                resColor: 'rgba(0, 0, 0, 0.7)',
                tableColor: '#2E291E',
                wifiIconColor: '#AC9988',
                wifiInFoColor: '#000000',
                wifiIconBorder: '2px solid #AC9988',
                tableIconBorder: '2px solid #AC9988',
                iconBorderColor: '#AC9988',
                cusCodeBorder: '4px solid #AC9988',
                tipBorderColor: '#cccccc',
                tipBorderFillColor: '#fff',
            })
        ],
        // 自定义 dark
        [
            QOP_TEMP.CUSTOMIZE_DARK,
            JSON.stringify({
                resColor: 'rgba(255, 255, 255, 0.7)',
                tableColor: '#FFFFFF',
                wifiIconColor: '#837D6F',
                wifiInFoColor: '#FFFFFF',
                wifiIconBorder: '2px solid #766E60',
                tableIconBorder: '2px solid #766E60',
                iconBorderColor: '#766E60',
                cusCodeBorder: '4px solid #766E60',
                tipBorderColor: '#464544',
                tipBorderFillColor: '#000',
            })
        ],
    ]);
    return statusText.get(sta) as string;
}

